module.exports = __webpack_public_path__ + "static/media/projects-cards.bff7a144.jpg";